// extracted by mini-css-extract-plugin
module.exports = {"Tickets":"style_Tickets__2i_1R"};